const generateUUID = require('uuid/v4');
/**
 * Churn survey service, used when user is downgrading from a paid to a free account.
 */
angular.module('hjApp').service('churnSurvey', function ($filter, $q, Account, Restangular, RestangularV2, $location) {
    var surveyId, siteId;

    /*************************
     * PUBLIC ACCESS FUNCTIONS
     *************************/

    this.get = function () {
        return Restangular.one('sites', 14)
            .one('surveys')
            .one('churn')
            .get()
            .then(function (response) {
                surveyId = response.survey.id;
                siteId = response.survey.site_id;
                return $q.resolve(response);
            });
    };

    /*
     * Submit the user's response to the churn survey.
     *
     * This first fetches the actual churn survey data from the backend,
     * assigns the user's response to the appropriate fields, then submits that
     * as a new response to the survey.
     *
     * It returns a Promise which always resolves no matter what happens with
     * the underlying web request, or a resolved promise if the survey ID is
     * falsey or the userResponse is falsey.
     *
     * TODO(rob.lester): Don't be so defensive about surveyId or userResponse,
     * raise an error or use TypeScript ;)
     */
    this.submit = function submit(userResponse, questionsFromServer) {
        if (surveyId && userResponse) {
            return (
                getResponseData(userResponse, questionsFromServer)
                    .then((surveyData) =>
                        RestangularV2.all('client')
                            .one('sites', siteId)
                            .one('poll', surveyId)
                            .one('response', generateUUID())
                            .customPOST({
                                action: 'create_or_update_poll_response',
                                response_content: JSON.stringify({
                                    answers: surveyData,
                                    version: 4 // survey response version number
                                }),
                                url: $location.absUrl()
                            })
                    )
                    // We are not actually going to deal with the error or success
                    //states so we use noop's.
                    .then(_.noop, _.noop)
            );
        } else {
            return $q.resolve();
        }
    };

    /*************************
     * PRIVATE FUNCTIONS
     *************************/

    function getResponseData(userResponse, questionsFromServer) {
        var account = Account.getOwned(),
            answers = [],
            promises = {
                sites: Account.getSites(account),
                users: Account.getUsers(account),
                paymentDetails: Restangular.one('accounts', account.id).one('payment').one('details').get()
            };

        function getUUIDByQuestionText(question_text) {
            const found = _.find(questionsFromServer, (question) => question.text === question_text);
            if (found) return found.uuid;
        }

        function addAnswerToChurnData(question, answer, uuid) {
            if (!uuid) uuid = getUUIDByQuestionText(question);

            answers.push({
                question: question,
                questionUuid: (uuid || '').substring(0, 8),
                comment: null,
                answer: answer
            });
        }

        return $q.all(promises).then(function (res) {
            // Reason for downgrading
            addAnswerToChurnData(
                userResponse.downgradeReason.question,
                userResponse.downgradeReason.answer,
                userResponse.downgradeReason.uuid
            );

            // Downgrade explanation
            addAnswerToChurnData(
                userResponse.downgradeExplanation.question,
                userResponse.downgradeExplanation.answer,
                userResponse.downgradeExplanation.uuid
            );

            // Likely to upgrade again
            addAnswerToChurnData(
                userResponse.likelyToUpgrade.question,
                userResponse.likelyToUpgrade.answer,
                userResponse.likelyToUpgrade.uuid
            );

            // Account ID
            addAnswerToChurnData('Account ID', account.id);

            // Is on Trial.
            addAnswerToChurnData(
                'Was paid customer prior to downgrade',
                Account.getTrialInfo(account).activeOrEligible ? 'No' : 'Yes'
            );

            // # of users associated to account.
            addAnswerToChurnData('Number of users', res.users.length);

            // # of sites associated to account.
            addAnswerToChurnData('Number of sites', res.sites.length);

            // Highest plan name.
            addAnswerToChurnData('Highest plan', account.highest_plan);

            // Account creation date.
            addAnswerToChurnData('Account creation date', $filter('epochDateTime')(account.created));

            // Account billing cycle.
            addAnswerToChurnData('Account billing cycle', account.billing_cycle);

            addAnswerToChurnData(
                'Industry',
                res.sites.reduce(function (industries, site, index) {
                    if (site.industry && site.industry.length) {
                        if (index > 0) {
                            industries += ', ';
                        }

                        industries += site.industry;
                    }

                    return industries;
                }, '')
            );

            addAnswerToChurnData(
                'Plan Rate',
                res.paymentDetails.billing_cycle === 'yearly_recurring'
                    ? res.paymentDetails.yearly_subtotal
                    : res.paymentDetails.monthly_subtotal
            );

            return answers;
        });
    }
});
